import { useMemo, useState } from 'react';
import { useFetch } from '../../../hooks/useFetch';
import { PaymentLinkView } from '../models/payment-link-view';
import {
  BroxelRawPaymentLinksResponse,
  mapBroxelRawToView,
} from '../models/broxel-raw-payment-link';
import { PAYMENT_LINKS_ENDPOINTS } from '../links.constants';

/**
 * Consume `GET bff/payment-links-view/broxel/raw` (passthrough CRUDO de Broxel)
 * para el bloque "Últimos Links Generados". Pide solo los últimos `size` (page 0),
 * y mapea la forma cruda de Broxel a `PaymentLinkView` para reutilizar la tabla
 * existente sin cambiarla. Solo lectura.
 */
export const useRecentBroxelLinks = (size = 3) => {
  const [reloadKey, setReloadKey] = useState(0);

  // Referencia estable de params (useFetch re-dispara al cambiar la referencia).
  // reloadKey permite forzar un refetch sin enviar parámetros extra a Broxel.
  const params = useMemo(() => ({ page: 0, size }), [size, reloadKey]);

  const { data, loading, error } = useFetch<BroxelRawPaymentLinksResponse>(
    PAYMENT_LINKS_ENDPOINTS.broxelRaw,
    params,
  );

  const records: PaymentLinkView[] = useMemo(
    () => (data?.data?.records ?? []).map(mapBroxelRawToView),
    [data],
  );

  const refetch = () => setReloadKey((k) => k + 1);

  return { records, loading, error, refetch };
};
